const r = (e, t) => e < t ? "complete" : t === e ? "active" : "default", n = (e) => e === "complete" ? "Completed" : e === "active" ? "Current step" : "";
export {
  n as getAriaFriendlyVariant,
  r as getStepVariant
};
